
import Footer from "./components/Footer"
import Header from "./components/Header"
import APPRoutes from "./routes/Routes"

function App() {

  return (
    <>


      <Header/> 
      <APPRoutes/>
      <Footer/>

      
      


    </>
  )
}

export default App
